import React, { useEffect, useState } from "react";
import "./administration.css";
import api from "../../service/caller";
export default function MedicationAdministration({ patientId, onMedicationChange, medicationRows: propRows  }) {
  const [UserData, setUserData] = useState();
  const [localRows, setLocalRows] = useState([
    {
      id: Date.now(),
      name: "",
      dosage: "",
      frequency: "",
      duration: "",
      price: ""
    }
  ]);

  const medicationRows = propRows ?? localRows;
  const setMedicationRows = propRows ? onMedicationChange : setLocalRows;

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        // toast.error("Failed to fetch data");
      }
    };
    const fetchTraitment = async () => {
      try {
        const response = await api.get(`api/treatment-plans/get-plan/${patientId._id}`);
        if (response.data.data.length > 0) {
          // Ensure each row has a unique id
          const medicationsWithIds = response.data.data[0].medications.map(med => ({
            ...med,
            id: med._id || Date.now() + Math.random()
          }));
          setMedicationRows(medicationsWithIds);
        }
      } catch (error) {
        // toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
    fetchTraitment();
  }, [patientId]);

  useEffect(() => {
    // Pass medicationRows data to parent component whenever it changes
    onMedicationChange(medicationRows);
  }, [medicationRows, onMedicationChange]);

  const addNewRow = () => {
    // Create a new empty row with a unique ID
    const newRow = {
      id: Date.now(), // Generate unique id using timestamp
      name: "",
      dosage: "",
      frequency: "",
      duration: "",
      price: ""
    };
    setMedicationRows([...medicationRows, newRow]);
  };

  const removeRow = (id) => {
    // Prevent removing the last row if it's the only one
    if (medicationRows.length <= 1) {
      return;
    }
    
    setMedicationRows((prevRows) => 
      prevRows.filter((row) => row.id !== id && row._id !== id)
    );
  };

  const handleChange = (id, field, value) => {
    setMedicationRows((prevRows) =>
      prevRows.map((row) =>
        (row.id === id || row._id === id) ? { ...row, [field]: value } : row
      )
    );
  };

  return (
    <div className="medication-container">
  {/* Liste des lignes de saisie */}
  <div className="medication-administration">
    {medicationRows.map((row, index) => (
      <div key={row.id || row._id} className="administration-row">
        <div className="administration-field">
          <label className="administration-label">Name</label>
          <input
            type="text"
            value={row.name || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "name", e.target.value)
            }
            className="administration-input"
          />
        </div>

        <div className="administration-field">
          <label className="administration-label">dosage</label>
          <input
            type="text"
            value={row.dosage || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "dosage", e.target.value)
            }
            className="administration-input administration-input-quantity"
          />
        </div>

        <div className="administration-field">
          <label className="administration-label">Frequency (hour)</label>
          <input
            type="number"
            value={row.frequency || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "frequency", e.target.value)
            }
            className="administration-input administration-input-time"
          />
        </div>

        <div className="administration-field">
          <label className="administration-label">Duration (day)</label>
          <input
            type="number"
            value={row.duration || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "duration", e.target.value)
            }
            className="administration-input administration-input-date"
          />
        </div>

        <div className="administration-field">
          <label className="administration-label">Price</label>
          <input
            type="number"
            value={row.price || ""}
            onChange={(e) =>
              handleChange(row.id || row._id, "price", e.target.value)
            }
            className="administration-input administration-input-date"
          />
        </div>

        {/* Buttons container for add and remove */}
        <div className="administration-buttons">
          {/* Remove button */}
          <button
            onClick={() => removeRow(row.id || row._id)}
            className="administration-add-btn"
            disabled={medicationRows.length <= 1}
            title={medicationRows.length <= 1 ? "Cannot remove the last treatment" : "Remove this treatment"}
          >
            -
          </button>
          
          {/* Add button only on the last row */}
          {index === medicationRows.length - 1 && (
            <button
              onClick={addNewRow}
              className="administration-add-btn"
            >
              +
            </button>
          )}
        </div>
      </div>
    ))}
  </div>
    </div>
  );
}